import { render, staticRenderFns } from "./mortgageList.vue?vue&type=template&id=4e3832b2&scoped=true&lang=html&"
import script from "./mortgageList.vue?vue&type=script&lang=js&"
export * from "./mortgageList.vue?vue&type=script&lang=js&"
import style0 from "./mortgageList.vue?vue&type=style&index=0&id=4e3832b2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e3832b2",
  null
  
)

export default component.exports